<template>
  <nav v-if="totalPages > 1" aria-label="Page navigation">
    <ul class="pagination justify-content-end push">
      <!-- First Page Button (Disabled if on first page) -->
      <li class="page-item" :class="{ disabled: currentPage === 1 }">
        <a class="page-link" href="javascript:void(0);" @click="changePage(1)">
          {{ paginationFirstText }}
        </a>
      </li>

      <!-- Ellipsis before numbered pages -->
      <li v-if="currentPage > 4" class="page-item disabled">
        <span class="page-link">...</span>
      </li>

      <!-- Numbered Page Buttons -->
      <li 
        v-for="i in pageNumbers" 
        :key="i" 
        class="page-item" 
        :class="{ active: i === currentPage }"
      >
        <a 
          class="page-link" 
          href="javascript:void(0);" 
          @click="changePage(i)"
        >
          {{ i }}
        </a>
      </li>

      <!-- Ellipsis after numbered pages -->
      <li v-if="currentPage < totalPages - 3" class="page-item disabled">
        <span class="page-link">...</span>
      </li>

      <!-- Last Page Button (Disabled if on last page) -->
      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
        <a class="page-link" href="javascript:void(0);" @click="changePage(totalPages)">
          {{ paginationLastText }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    totalPages: { type: Number, required: true },
    currentPage: { type: Number, required: true },
    paginationFirstText: { type: String, default: 'First' },
    paginationLastText: { type: String, default: 'Last' }
  },
  computed: {
    pageNumbers() {
      const start = Math.max(1, this.currentPage - 2);
      const end = Math.min(this.totalPages, this.currentPage + 2);
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  methods: {
    changePage(page) {
      if (page !== this.currentPage) {
        this.$emit("page-change", page);
      }
    }
  }
};
</script>
